import React from 'react';

/** Optional subtle radial glow behind placeholders — does not change outer dimensions. */
export const HomepageImageGlowWrap: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => (
  <div className={`relative flex w-full flex-col ${className}`}>
    <div
      className="pointer-events-none absolute inset-0 rounded-2xl bg-[radial-gradient(circle_at_30%_40%,rgba(0,227,255,0.06),transparent_70%)]"
      aria-hidden
    />
    <div className="relative z-[1] flex min-h-0 flex-1 flex-col">{children}</div>
  </div>
);
